// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","250":"0f1d58a7","420":"03427317","458":"fb796acd","577":"66801e42","652":"0643e35d","660":"ed5bc0b8","682":"d5252985","783":"c66ca607","793":"25f7d366","812":"595909e7","867":"d668db6e","904":"0c67cfd9","985":"de897744"}[chunkId] + ".js";
};